import OverLayIU from "./overlay_ui";
import React, { useEffect, useContext, useState } from "react";
import IconUI from "./icon_ui";
import { IoIosCloseCircle } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useNavigate } from "react-router-dom";
import { services, token } from "../../services/api";
import { NotificacionContext } from "../../context/notificacion_context";


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';



export default function PopUp({ onClose, dataItem }) {
  const { showNotification } = useContext(NotificacionContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [, setIdsSeleccionados] = useState([]);

  // Alerta
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose1 = () => {
    setOpen(false);
  };


  const [errorMostrado, setErrorMostrado] = useState(false); //para notificacion de error

  const handleClick = () => {
    setIdsSeleccionados((prevIds) => {
      if (!prevIds.includes(dataItem.id)) {
        handleClose();
        const nuevoId = [...prevIds, dataItem.id];
        localStorage.setItem("idsSeleccionados", JSON.stringify(nuevoId));
        showNotification(
          "success",
          "¡Se agregó al carrito!",
          "", null, 2
        );
        setErrorMostrado(false); // Reinicia el error si se agrega correctamente
        return nuevoId;
      } else {
        handleClose();
        if (!errorMostrado) {
          showNotification(
            "error",
            "¡Ya está en el carrito!",
            "", null, 2
          );
          setErrorMostrado(true); // Marca que ya se mostró el error
        }
        return prevIds;
      }
    });
  };


  // Guardar Id en localstorage
  useEffect(() => {
    const stored = localStorage.getItem("idsSeleccionados");
    setIdsSeleccionados(stored ? JSON.parse(stored) : []);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dataItem]);

  const handleClose = () => {
    onClose();
  };

  const inscribiralumno = async (data) => {
    if (token()) {
      if (data.idtaller) {
        const dataIscripcion = await services(
          "GET",
          `usuarios/crearinscripcionalumno?taller=${data.id}`,
          null
        );

        if (dataIscripcion.status === 200) {
          if (dataIscripcion.data.created === false) {
            showNotification(
              "warning",
              "Alerta!",
              dataIscripcion.data.mensaje,
              null,
              4
            );
          } else if (dataIscripcion.data?.create === false) {
            showNotification(
              "warning",
              "Alerta!",
              dataIscripcion.data.error,
              null,
              4
            );
          } else {
            showNotification(
              "success",
              "Acción Exitosa!",
              "El alumno se inscribió correctamente.",
              null,
              4
            );
            navigate("/mis-cursos");
          }
        } else {
          showNotification(
            "error",
            "Algo salió mal",
            dataIscripcion.error,
            null,
            4
          );
        }
      } else {
        showNotification(
          "error",
          "Algo salió mal",
          "No se pudo acceder a la Base de datos, consulta al administrador.",
          null,
          4
        );
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <>

      {dataItem.estatus === 1 ? (
        <>
          <OverLayIU onClick={handleClose} />
          <div className="wizard">
            <div className="bg-morado d-flex align-items-center">
              <div className="col">
                <div className="m-3 text-big text-white text-bold">
                  {dataItem.nombretaller}
                </div>
              </div>
              <div className="cursor-pointer me-3" onClick={handleClose}>
                <IconUI color={"#ffff"} size={"30px"}>
                  <IoIosCloseCircle />
                </IconUI>
              </div>
            </div>
            <div className="container">
              <div className="row mt-3">
                <div className="col mt-2 ">
                  <div style={{ height: "350px", width: "100%", }}>
                    <Swiper
                      navigation={true}
                      modules={[Navigation]}
                      className="mySwiper"
                    >
                      {dataItem.fotos.map((foto, i) => (
                        <SwiperSlide key={i}>
                          <div className="d-flex align-items-center fotopopUp">
                            <img
                              src={
                                foto.foto
                                  ? foto.foto
                                  : "https://images.pexels.com/photos/3971983/pexels-photo-3971983.jpeg?auto=compress&cs=tinysrgb&w=600"
                              }
                              alt=""
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
                <div className="col">
                  <div className="card my-3" style={{ height: "120px" }}>
                    <div className="text--morado text-center text-bold borderBottomTitulo">
                      NIVEL
                    </div>
                    <div className="text-center">{dataItem.nivel}</div>
                  </div>
                  <div className="card" style={{ height: "200px" }}>
                    <div className="my-3 text--morado text-center text-bold borderBottomTitulo">
                      DESCRIPCIÓN
                    </div>
                    <div>{dataItem.descripciontaller}</div>
                  </div>
                </div>
              </div>
              <div className="my-3 text--morado text-bold borderBottomTitulo">
                {" "}
                INFORMACIÓN DE TALLER{" "}
              </div>
              <ul>
                <li>
                  <div>Horario: {dataItem.horariotaller}</div>
                </li>
                <li>
                  <div>Edad: {dataItem.rango}</div>
                </li>
                <li>
                  <div>Maestro: {dataItem.profesor}</div>
                </li>
                <li>
                  <div>Salón: {dataItem.salon}</div>
                </li>
                <li>
                  <div>Cupo máximo: {dataItem.capacidad}</div>
                </li>




                <li>

                  <div>
                    {dataItem.disponibles <= 0 ? (
                      <span style={{ color: "red", fontWeight: "bold" }}>Cupo lleno</span>
                    ) : (
                      <span>Cupos disponibles: {dataItem.disponibles}</span>
                    )}
                  </div>
                </li>


                <li>
                  <div>
                    Fecha inicio inscripción: {dataItem.fechaincrpcioninicio}
                  </div>
                </li>
                <li>
                  <div>Fecha fin inscripción: {dataItem.fechaincrpcionfin}</div>
                </li>
              </ul>
              <div className="my-3 d-flex justify-content-center">




                {dataItem.disponibles <= 0 ? (
                  <span style={{ color: "red", fontWeight: "bold" }}>Inscripción Cerrada</span>
                ) : (
                  <> {/**/}
                    <>
                      {localStorage.getItem("rol") === "Profesor" ? (<></>) : (<>
                        {token() ? (
                          <button className="bg-rosaClaro p-2 rounded border w-25" variant="outlined" onClick={handleClick}>
                            Añadir al Carrito
                          </button>
                        ) : (<>
                          <button className=" cta--guinda p-2 rounded border w-25 me-3" variant="outlined" onClick={handleClickOpen}>
                            Inscribirme
                          </button>
                        </>)}
                      </>)}



                      <Dialog
                        fullScreen={fullScreen}
                        open={open}
                        onClose={handleClose1}
                        aria-labelledby="responsive-dialog-title"
                      >

                        <DialogContent>
                          <DialogContentText>
                            ¿Estás seguro, de inscribirte a este curso?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <button className="bg-rosaClaro p-2 rounded border w-25" autoFocus onClick={handleClose1}>

                            No
                          </button>

                          <button
                            className="cta cta--guinda cta--small"
                            onClick={() => {
                              window.localStorage.setItem("tallerSelected", dataItem.id);
                              inscribiralumno(dataItem);
                              handleClose();
                            }}
                          >
                            Si, Continuar
                          </button>
                        </DialogActions>
                      </Dialog>
                    </></>


                )}

              </div>
            </div>
          </div>
        </>
      ) : null}




    </>
  );
}
